'use client'
import { useEffect } from 'react'
import { useBooking } from '../../model/bookingContext'
import { BookingStepEnum } from '../../model/bookingTypes'
import { SpecialitiesStep } from './Specialities'
import { MeetingPlaceStep } from './MeetingPlace'
import { AvailabilitiesStep } from './Availabilities'
import { CompanionStep } from './CompanionStep'
import { ConsentStep } from './ConsentStep'
import { ConsultationModeStep } from './ConsultationMode'
import { LocationStep } from './LocationStep'
import { PatientInfoStep } from './PatientInfo'
import { ExpertiseInfoStep } from './ExpertiseInfo'
import { FormSubmissionStep } from './FormSubmission'
import { PaymentStep } from './Payment'
import { ConfirmationStep } from './Confirmation'
import { useSyncContext } from '../../model/useSyncContext'
import { isStepCompleted } from '../../lib/bookingUtils'

export function BookingSteps() {
  const { dispatch, getVisibleSteps, state } = useBooking()
  useSyncContext(state.meetingLinkSlug)

  const visibleSteps = getVisibleSteps()

  useEffect(() => {
    const currentStep = visibleSteps.find((step) => step.key === state.currentStep)
    if (currentStep) return
    let stepIndex = 0
    while (isStepCompleted(visibleSteps[stepIndex].key, state) && stepIndex < visibleSteps.length) {
      stepIndex++
    }
    dispatch({ type: 'SET_CURRENT_STEP', payload: visibleSteps[stepIndex].key })
  }, [dispatch, state, visibleSteps])

  if (state.currentStep === BookingStepEnum.CONFIRMATION) return <ConfirmationStep />

  return (
    <>
      <div className="hidden md:flex flex-col gap-4">{visibleSteps.map((step) => renderStep(step.key))}</div>
      <div className="md:hidden">{renderStep(state.currentStep)}</div>
    </>
  )
}

function renderStep(step: BookingStepEnum) {
  switch (step) {
    case BookingStepEnum.AVAILABILITIES:
      return <AvailabilitiesStep key={step} />
    case BookingStepEnum.COMPANION:
      return <CompanionStep key={step} />
    case BookingStepEnum.CONSENT:
      return <ConsentStep key={step} />
    case BookingStepEnum.CONSULTATION_MODE:
      return <ConsultationModeStep key={step} />
    case BookingStepEnum.EXPERTISE_INFORMATION:
      return <ExpertiseInfoStep key={step} />
    case BookingStepEnum.FORM_SUBMISSION:
      return <FormSubmissionStep key={step} />
    case BookingStepEnum.LOCATION:
      return <LocationStep key={step} />
    case BookingStepEnum.MEETING_PLACE:
      return <MeetingPlaceStep key={step} />
    case BookingStepEnum.PATIENT_INFORMATION:
      return <PatientInfoStep key={step} />
    case BookingStepEnum.PAYMENT:
      return <PaymentStep key={step} />
    case BookingStepEnum.SPECIALITIES:
      return <SpecialitiesStep key={step} />
    default:
      return null
  }
}
